import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { selectPostThanksGiving } from "@/store/redux";
import {
  Bubble,
  Dialog,
  DialogMessageContent,
  GradientButton,
} from "@/shared/components";
import { ThanksGivingDayForm } from "./ThanksGivingDayForm";

interface IThanksGivingDialogProps {
  open: boolean;
  onClose: () => void;
}

// const thanksGivingText = {
//   dialogTitle: {
//     hasPosted: "THANK YOU!",
//     default: "THANKSGIVING DAY MARATHON!",
//   },
//   contentTitle: {
//     hasPosted: "We've got your “Thank you”!",
//     default: "",
//   },
//   contentDesc: {
//     hasPosted:
//       "We will deliver your message to your bright colleague no matter what!",
//     default:
//       "Today is a day to say “Thank you” to your colleagues, mates and friends at work. Write a short text or select a ready-made note.",
//   },
// };

const womansDayText = {
  dialogTitle: {
    hasPosted: "THANK YOU!",
    default: "INTERNATIONAL WOMEN'S DAY",
  },
  contentTitle: {
    hasPosted: "Your message is on its way!",
    default: "",
  },
  contentDesc: {
    hasPosted:
      "We will deliver your message to your bright colleague no matter what!",
    default:
      "Take a moment to send a personal note to the women you work with. Write your own message or choose a ready-made one to show your support and appreciation. ",
  },
};

export function ThanksGivingDialog(props: IThanksGivingDialogProps) {
  const { open, onClose } = props;
  const { contentDesc, contentTitle, dialogTitle } = womansDayText;

  const { hasPosted } = useSelector(selectPostThanksGiving);

  const dialogMaxWidth = hasPosted ? "xsm" : "smd";
  const title = hasPosted ? dialogTitle.hasPosted : dialogTitle.default;

  const content = hasPosted ? (
    <DialogMessageContent
      title={contentTitle.hasPosted}
      description={contentDesc.hasPosted}
      icon={
        <Bubble color="yellowPink" width="100px" height="100px">
          <CheckIcon sx={{ fontSize: 56 }} />
        </Bubble>
      }
      action={
        <GradientButton fullWidth onClick={onClose}>
          Got it
        </GradientButton>
      }
    />
  ) : (
    <Box sx={{ px: { xs: 0, sm: 5 } }}>
      <Box
        sx={{
          textAlign: { xs: "justify", sm: "left" },
          fontSize: { xs: 14, sm: 18 },
          fontWeight: 400,
          mb: 4,
        }}
      >
        {contentDesc.default}
      </Box>
      <ThanksGivingDayForm />
    </Box>
  );

  return (
    <Dialog
      top
      fullWidth
      scroll="body"
      maxWidth={dialogMaxWidth}
      title={title}
      dialogContent={content}
      open={open}
      onClose={onClose}
    />
  );
}

